import CitySEOHead from "@/components/feature/CitySEOHead";
import LaGrangeHeroSection from "./components/HeroSection";
import LaGrangeStickyNav from "./components/StickyNav";
import LaGrangeProcessingTimeSection from "./components/ProcessingTimeSection";
import LaGrangeServicesSection from "./components/ServicesSection";
import LaGrangeLocalAreaSection from "./components/LocalAreaSection";
import LaGrangeTestimonialsSection from "./components/TestimonialsSection";
import LaGrangeAcceptanceFacilitiesSection from "./components/AcceptanceFacilitiesSection";
import LaGrangeComparisonSection from "./components/ComparisonSection";
import LaGrangeMistakesSection from "./components/MistakesSection";
import LaGrangeHowItWorksSection from "./components/HowItWorksSection";
import LaGrangeFAQSection, { faqs } from "./components/FAQSection";
import LaGrangeHelpfulResourcesSection from "./components/HelpfulResourcesSection";
import LaGrangeFinalCTA from "./components/FinalCTA";
import SEOCrossLinks from "@/components/feature/SEOCrossLinks";

const laGrangeServices = [
  { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
  { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
  { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
  { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
  { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
  { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  { name: "Second Passport & Damaged", description: "Second passport issuance for frequent travelers and damaged passport replacement." },
];

export default function LaGrangePage() {
  return (
    <div className="font-sans">
      <CitySEOHead
        city="La Grange"
        state="Georgia"
        stateAbbr="GA"
        route="/cities/lagrange"
        title="Emergency Passport LaGrange, GA — Expedited & Fast Passport Service | Fast Passport Center"
        description="Emergency and expedited passport services in La Grange, GA — as fast as 24 hours. Same-day courier processing available. A+ BBB rated, registered State Dept. courier serving Troup County and west Georgia travelers. Get your emergency passport fast!"
        geoPlacename="La Grange, Georgia"
        geoPosition="33.0393;-85.0313"
        faqs={faqs}
        servicesSchema={laGrangeServices}
        statePageName="Georgia"
        statePageRoute="/states/georgia"
        keywords="expedited passport, emergency passport, La Grange passport, same day passport La Grange, fast passport Georgia, Troup County passport"
      />
      <LaGrangeHeroSection />
      <LaGrangeStickyNav />
      <LaGrangeProcessingTimeSection />
      <LaGrangeServicesSection />
      <LaGrangeLocalAreaSection />
      <LaGrangeTestimonialsSection />
      <LaGrangeAcceptanceFacilitiesSection />
      <LaGrangeComparisonSection />
      <LaGrangeMistakesSection />
      <LaGrangeHowItWorksSection />
      <LaGrangeFAQSection />
      <LaGrangeHelpfulResourcesSection />
      <SEOCrossLinks currentRoute="/cities/lagrange" state="GA" />
      <LaGrangeFinalCTA />
    </div>
  );
}